import { useQuery } from "@tanstack/react-query";

import { bffAxios } from "@av/config/api-config/axios-config";
import { platformQueryKeys } from "../platform-query-key-factory";
import {
  type HrAdminSettingsUser,
  type ProductCode,
  type SecurityGroup,
  securityGroupsQueryKeyMap,
  type SecurityGroupSummary,
  type SelectOption,
} from "./type";

export function useFetchSecurityGroupUsers(groupId?: string) {
  return useQuery({
    queryKey: platformQueryKeys.securityGroupUsers(groupId ?? ""),
    enabled: groupId !== undefined,
    queryFn: async (): Promise<HrAdminSettingsUser[]> => {
      const { data } = await bffAxios.get<{ items: HrAdminSettingsUser[] }>(
        `/company/security-groups/${encodeURIComponent(groupId ?? "")}/users`
      );

      return data.items;
    },
  });
}

export function useFetchSecurityGroups(productCode: ProductCode) {
  const queryKey = securityGroupsQueryKeyMap[productCode];

  return useQuery<SelectOption[]>({
    queryKey,
    queryFn: async (): Promise<SelectOption[]> => {
      const { data } = await bffAxios.get(`/company/security-groups/${productCode}`);

      return data.items.map((group: SecurityGroup) => ({
        label: group.name,
        value: group.id,
      }));
    },
  });
}

export function useFetchSecurityGroupSummaries() {
  return useQuery<SecurityGroupSummary[]>({
    queryKey: platformQueryKeys.securityGroupSummaries(),
    queryFn: async (): Promise<SecurityGroupSummary[]> => {
      const { data } = await bffAxios.get<{ items: SecurityGroupSummary[] }>(
        "/company/security-group-summaries"
      );

      return data.items;
    },
  });
}
